// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"897":"4f7b2eb0","990":"7a2cc91e"}[chunkId] + ".chunk.js";
};